module.exports = __webpack_public_path__ + "static/comment-forum-web-app-developed-by-dallas-boyer.8e9bd51a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/config/img/comment-forum-web-app-developed-by-dallas-boyer.jpg
// module id = 192
// module chunks = 35783957827783 70144966829960 114276838955818 263791100135453